import React, { useState, useEffect } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';    // 月曆視圖
import listPlugin from '@fullcalendar/list';          // 清單視圖
import dayjs from 'dayjs';
import EventDetail from './EventDetail';
import ReservationSearchModal from './ReservationSearchModal';

function EventList() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showSearchModal, setShowSearchModal] = useState(false);
  const [showIntroductionModal, setShowIntroductionModal] = useState(false);
  const [activeTab, setActiveTab] = useState('englishTable');
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [errorMsg, setErrorMsg] = useState('');


useEffect(() => {
  fetch('http://140.117.214.67:3000/api/events')
    .then((res) => res.json())
    .then((data) => {
      const today = dayjs().startOf('day');
      const upcomingEvents = data.filter(evt => dayjs(evt.date).isSame(today) || dayjs(evt.date).isAfter(today));
      setEvents(upcomingEvents);
      setLoading(false);
    })
    .catch((err) => {
      console.error('取得活動列表失敗：', err);
      setLoading(false);
    });
}, []);

  if (loading) {
    return <p className="text-center">載入中...</p>;
  }

function canReserveAndReason(evt) {
  if (evt.availableSpots === 0) {
    return { canReserve: false, reason: '此活動已額滿 (Registration is full)' };
  }
  const now = dayjs();
  const eventStart = dayjs(`${evt.date}T${evt.startTime}`);
  if (now.isAfter(eventStart)) {
    return { canReserve: false, reason: '活動已開始，無法預約 (The event has already started, reservation is not possible)' };
  }
  const openStart = eventStart.subtract(1, 'day').startOf('day');
  const openEnd = eventStart.subtract(2, 'hour');
  if (now.isBefore(openStart)) {
    return {
      canReserve: false,
      reason: `尚未到開放預約時間 (開放時間：${openStart.format('YYYY/MM/DD HH:mm')} - ${openEnd.format('YYYY/MM/DD HH:mm')}) (Reservation is not yet available. Available : ${openStart.format('YYYY/MM/DD HH:mm')} - ${openEnd.format('YYYY/MM/DD HH:mm')})`
    };
  }
  if (now.isAfter(openEnd)) {
    return { canReserve: false, reason: '已超過開放預約時間，無法預約 (The reservation window has passed, and you cannot reserve now)' };
  }
  return { canReserve: true, reason: '' };
}


  const calendarEvents = events.map((evt) => {
    const startDateTime = `${evt.date}T${evt.startTime}`;
    const endDateTime = `${evt.date}T${evt.endTime}`;
    return {
      id: evt.id,
      title: evt.name,
      start: startDateTime,
      end: endDateTime,
      extendedProps: { originalEvent: evt },
    };
  });

  const handleEventClick = (info) => {
    const { originalEvent } = info.event.extendedProps;
    const { canReserve, reason } = canReserveAndReason(originalEvent);
    if (canReserve) {
      setSelectedEvent(originalEvent);
    } else {
      setErrorMsg(reason);
    }
  };

  
  const renderEventContent = (eventInfo) => {
    const evt = eventInfo.event.extendedProps.originalEvent;
    const isMobile = window.innerWidth < 576;
    const { canReserve } = canReserveAndReason(evt);
    const dotColor = canReserve ? 'text-success' : 'text-danger';

  // 1) 如果是手機且名稱是 "English Table"，就用 "ET" 替代
  let displayedName = evt.name;
  if (isMobile && displayedName === 'English Table') {
    displayedName = 'ET';
  }

  return isMobile ? (
    // 手機呈現
    <div className="px-2 py-1" style={{ fontSize: '0.75rem', overflow: 'hidden' }}>
      <span className={dotColor} style={{ marginRight: 4 }}>●</span>
      <div className="fw-bold">{displayedName}</div>
    </div>
  ) : (
    // 桌機呈現
    <div className="ps-3" style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
      <span className={`fs-5 ${dotColor}`}>●</span>
      <div className="fw-bold">{evt.name}</div>
      <div>{evt.startTime} - {evt.endTime}</div>
    </div>
  );
  };

  const handleTabChange = (tabKey) => {
    setActiveTab(tabKey);
  };

  return (
    <div className="container-fluid mt-4">
      <div className="row">
        <div className="col-md-12">
          <div className="d-flex justify-content-end align-items-center mb-3">
            <button
              className="btn btn-primary me-2"
              onClick={() => setShowSearchModal(true)}
            >
              查詢預約紀錄 Check Your Reservation
            </button>
            <button
              className="btn btn-info"
              onClick={() => setShowIntroductionModal(true)}
            >
              活動介紹 Event Introdution
            </button>
          </div>

          <FullCalendar
            plugins={[dayGridPlugin, listPlugin]}
            initialView={window.innerWidth < 576 ? "listWeek" : "dayGridMonth"}
            events={calendarEvents}
            eventContent={renderEventContent}
            eventClick={handleEventClick}
            height={600}
            headerToolbar={{
              left: 'prev,next today',
              center: 'title',
              right: 'dayGridMonth,listWeek'
            }}
            views={{
              dayGridMonth: { buttonText: '月 Month' },
              listWeek: { buttonText: '清單 List' },
            }}
          />
        </div>
      </div>

      {showSearchModal && (
        <ReservationSearchModal
          show={showSearchModal}
          onClose={() => setShowSearchModal(false)}
        />
      )}

      {selectedEvent && (
        <EventDetail
          show={true}
          event={selectedEvent}
          onClose={() => setSelectedEvent(null)}
        />
      )}

      {errorMsg && (
        <>
          <div className="modal fade show" style={{ display: 'block' }} role="dialog">
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">提示訊息</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setErrorMsg('')}
                  />
                </div>
                <div className="modal-body">
                  <p>{errorMsg}</p>
                </div>
                <div className="modal-footer">
                  <button
                    className="btn btn-danger"
                    onClick={() => setErrorMsg('')}
                  >
                    關閉
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show" />
        </>
      )}

      {showIntroductionModal && (
        <>
          <div className="modal fade show" style={{ display: 'block' }} role="dialog">
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">活動介紹</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowIntroductionModal(false)}
                  />
                </div>
                <div className="modal-body">
                  <ul className="nav nav-tabs mb-3">
                    <li className="nav-item">
                      <button
                        className={`nav-link ${activeTab === 'englishTable' ? 'active' : ''}`}
                        onClick={() => handleTabChange('englishTable')}
                      >
                        English Table
                      </button>
                    </li>
                    <li className="nav-item">
                      <button
                        className={`nav-link ${activeTab === 'internationalForum' ? 'active' : ''}`}
                        onClick={() => handleTabChange('internationalForum')}
                      >
                        International Forum
                      </button>
                    </li>
                    <li className="nav-item">
                      <button
                        className={`nav-link ${activeTab === 'englishClub' ? 'active' : ''}`}
                        onClick={() => handleTabChange('englishClub')}
                      >
                        English Club
                      </button>
                    </li>
                  </ul>

                  <div>
                    {activeTab === 'englishTable' && (
                      <div>
                        <img
                          src="/images/english_table.jpg"
                          alt="English Table"
                          className="img-fluid mb-3 rounded"
                        />
                        <p>
                          在這個活動中，我們結合了創新的英語教學方式，強調課程共學與國際交流。學生們可以參與約30分鐘的課程，進行雙語學習與討論。
                        </p>
                        <p>
			   English Table is an innovative teaching approach integrated with English courses, primarily designed to complement teachers' curriculum planning and conducted in approximately 30-minute sessions. The activity focuses on 'collaborative course learning' and 'international exchange.'
                        </p>
                      </div>
                    )}
                    {activeTab === 'internationalForum' && (
                      <div>
                        <img
                          src="/images/international_forum.jpg"
                          alt="International Forum"
                          className="img-fluid mb-3 rounded"
                        />
                        <p>
                          我們邀請本地學生與國際學生共同參與，透過討論國際議題與文化差異，增進彼此的理解與思維，拓展視野。
                        </p>
                        <p>
			   The International Forum connects local and international students through a variety of engaging topics, such as current global issues, cross-cultural differences, and contemporary events, fostering mutual exchange and enhancing cultural and customary understanding between various countries and Taiwan. This activity format cultivates students' diverse critical thinking skills and improves their English oral communication abilities.
                        </p>
                      </div>
                    )}
                    {activeTab === 'englishClub' && (
                      <div>
                        <img
                          src="/images/english_club.jpg"
                          alt="English Club"
                          className="img-fluid mb-3 rounded"
                        />
                        <p>
                          透過外籍業師的指導，我們將進行主題式的討論，提升學生們的批判性思考與英語表達能力，並且鼓勵學生積極參與互動。
                        </p>
                        <p>
                          The English Club, led by Andy Worcester (王安迪) and a team of foreign professional instructors, cultivates students' diverse critical thinking skills through immersive learning and thematic discussions. Additionally, it enhances students' English oral communication abilities through interactive sessions.
                        </p>
                      </div>
                    )}
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setShowIntroductionModal(false)}
                  >
                    關閉
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="modal-backdrop fade show" />
        </>
      )}
    </div>
  );
}

export default EventList;
